import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BagsJobsPageRoutingModule } from './bags-jobs-routing.module';

import { BagsJobsPage } from './bags-jobs.page';
import { BottombarComponent } from '../components/bottombar/bottombar.component';
import { CvPage } from './cv/cv.page';
import { CompanyPage } from './company/company.page';
import { CvPageModule } from './cv/cv.module';
import { CompanyPageModule } from './company/company.module';
import { FooterComponentModule } from '../components/footer-component.module';
import { SectionAdvertisementsComponent } from '../components/section-advertisements/section-advertisements.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BagsJobsPageRoutingModule,
     CvPageModule,
     CompanyPageModule,
     FooterComponentModule
  ],
  declarations: [BagsJobsPage, SectionAdvertisementsComponent]
})
export class BagsJobsPageModule {}
